import { useState } from "react";
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import "./style.css";

function App() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#2EE59D");
  setInterval(() => {
    setLoading(false)
  }, 5000);
  return (
    loading 
    ?
    <div className="loading">
      <ClimbingBoxLoader color={color} loading={loading} size={20} />
    </div>
    :
    <div></div>
  );
};

export default App;